export default {"src":"/_next/static/media/checkmark-blue-icon.42930491.svg","height":23,"width":25,"blurWidth":0,"blurHeight":0};